import type { Address } from '../types/codexOrder';

export function parseMapsPlace(place: google.maps.places.Place): Address {
  const addressComponents = place.addressComponents ?? [];

  const getComponent = (types: string[]): string => {
    const component = addressComponents.find(comp =>
      types.some(type => comp.types.includes(type)),
    );
    return component?.longText ?? '';
  };

  const line_1 =
    [
      getComponent(['street_number']),
      getComponent(['route']),
      getComponent(['premise']),
    ]
      .filter(Boolean)
      .join(', ') ?? '';

  const sub_locality =
    [
      getComponent(['sublocality_level_2']),
      getComponent(['sublocality_level_1']) ||
        getComponent(['sublocality']) ||
        getComponent(['neighborhood']),
    ]
      .filter(Boolean)
      .join(', ') ?? '';

  const city =
    [
      getComponent(['locality']) ||
        getComponent(['administrative_area_level_3']) ||
        getComponent(['postal_town']),
      getComponent(['administrative_area_level_1']),
      getComponent(['country']),
    ]
      .filter(Boolean)
      .join(', ') ?? '';

  const pin = getComponent(['postal_code']);
  const lat = place.location?.lat() ?? 0;
  const lng = place.location?.lng() ?? 0;

  return {
    pin,
    city,
    line_1,
    sub_locality,
    latitude: lat,
    longitude: lng,
  };
}
